import(/* webpackMode: "eager" */ "/app/main/app/[locale]/coding/list/page.tsx");
